export * from './EGrupoProduto';
